import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getFontById } from "../../../api/fontService";

export default function ViewFont() {
  const location = useLocation();
  const id = location?.state?.fontId;

  const [font, setFont] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchFont = async () => {
    try {
      setLoading(true);

      const response = await getFontById(id);

      setFont(response?.data || response);
    } catch (error) {
      console.error("Error fetching font:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchFont();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body text-center py-4">
            Loading...
          </div>
        </div>
      </div>
    );
  }

  if (!font) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body text-center py-4">
            Font not found
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-4">
      <div className="card p-3 d-flex justify-content-between">
        

        <div className="row g-3">
          <div className="col-md-4">
            <span className="fw-bold">Font Name : </span>
            {font.name || "N/A"}
          </div>

          <div className="col-md-4">
            <span className="fw-bold">Font Value : </span>
            {font.value || "N/A"}
          </div>

          <div className="col-md-4">
            <span className="fw-bold">Status : </span>
            <span
              className={`badge ${
                font.status === "ACTIVE"
                  ? "bg-success"
                  : "bg-danger"
              }`}
            >
              {font.status || "INACTIVE"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}